import { createContext } from 'react';

/** What a page with unsaved changes offers to code that wants to leave it without a navigation, such as sign-out. */
export interface LeaveCheck {
  /** Shows the "Leave without saving?" dialog. Resolves true if the reader chose to leave. */
  confirmLeave: () => Promise<boolean>;
  /** Lets the next in-app navigation through without asking again. */
  allowNextNavigation: () => void;
}

/** The page's current check, or null when nothing is unsaved. */
export interface LeaveGuardRegistry {
  current: LeaveCheck | null;
}

/**
 * Provided by SessionProvider. Sign-out ends the session before it navigates,
 * so it cannot rely on the router's blocker: once the session is gone the
 * protected page unmounts, blocker and all. It asks the page first instead.
 */
export const LeaveGuardContext = createContext<LeaveGuardRegistry | null>(null);
